<!-- header头部 -->
<template>
  <header>
    <div class="main">
      <div>
        <img
          src="@/assets/headers/logo.png"
          @click="toIndex"
          class="logo"
          alt
        />
      </div>
      <div class="head_nav">
        <ul class="displayFlex">
          <li :class="navActI == 1 ? 'active' : ''" @click="toIndex">首页</li>
          <li :class="navActI == 2 ? 'active' : ''" @click="toRecruit">
            任务大厅
          </li>
          <li :class="navActI == 4 ? 'active' : ''" @click="toZMList">
            招募大厅
          </li>
          <li :class="navActI == 3 ? 'active' : ''" @click="toCategory">
            行业资讯
          </li>
          <!-- <li :class="navActI == 4 ? 'active' : ''" @click="toCAT">辅助翻译</li> -->
          <li :class="navActI == 5 ? 'active' : ''" @click="toAbout">
            关于我们
          </li>
        </ul>
      </div>
      <div class="realuserBox">
        <el-popover
          placement="bottom"
          width="400"
          trigger="hover"
          popper-class="messagePop"
          v-show="userId"
          @show="getMsgList1()"
        >
          <div class="messageBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="任务消息" name="a" :disabled="tabFlag" lazy>
                <!-- <el-button type="primary" size="default" @click="clickME"
                  >点我</el-button
                >
                <el-button type="primary" size="default" @click="guanbi"
                  >关闭</el-button
                > -->
                <ul
                  style="overflow-y: auto; width: 377px"
                  v-infinite-scroll="load1"
                  :infinite-scroll-disabled="isInfiniteScrollDisabled1"
                >
                  <li
                    class="message"
                    v-for="(item, index) in tableData1"
                    :key="index"
                    @click="
                      getRead(item.km_id, item.km_task_id, item.km_message)
                    "
                  >
                    <p
                      class="t1"
                      v-if="item.openTask"
                      :style="item.km_reading ? 'color:#8D92A3' : ''"
                    >
                      {{ item.openTask.ot_name }}
                    </p>
                    <p
                      class="t2"
                      :style="item.km_reading ? 'color:#8D92A3' : ''"
                    >
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="
                          item.km_message == 10000
                            ? '恭喜您通过领域测试，请等待平台与您联系签约'
                            : item.km_message == 10001
                            ? '很遗憾，您本次领域测试未通过，我们期待您下次的佳绩！'
                            : item.km_message == 10100
                            ? '恭喜您，您已获得参加领域测试的资格，可以去参加领域测试了'
                            : item.km_message == 10101
                            ? '经人工审核，您未获得领域测试资格。查看失败原因请前往“成为译员”页面，点击下方“查看申请结果”进行查看。'
                            : item.km_message == 20000
                            ? '项目对接人向您指派了一条任务，请及时处理。'
                            : item.km_message == 20401
                            ? '项目对接人关闭了任务，如有问题请于项目对接人联系。'
                            : item.km_message == 20210
                            ? '项目对接人已完成任务准备，请您开始任务。'
                            : item.km_message == 20500
                            ? '项目对接人暂停了任务，如有问题请与项目对接人联系。'
                            : item.km_message == 20501
                            ? '项目对接人已对任务进行变更，请在与项目对接人充分沟通的基础上考虑是否接受变更。'
                            : item.km_message == 20503
                            ? '项目对接人已解除了任务暂停，请按要求继续任务。'
                            : item.km_message == 20305
                            ? '项目对接人发起了返稿修改，请您根据项目对接人要求对任务结果进行调整。'
                            : item.km_message == 20306
                            ? '项目对接人发起了售后工单，请您积极配合修改，以免对您的平台信誉产生影响。'
                            : item.km_message == 20400
                            ? '项目对接人取消了任务，如有问题请于项目对接人联系。'
                            : ''
                        "
                        placement="bottom"
                      >
                        <span
                          style="
                            display: inline-block;
                            overflow: hidden; /*内容超出后隐藏*/
                            text-overflow: ellipsis; /*超出内容显示为省略号*/
                            white-space: nowrap; /*文本不进行换行*/
                          "
                          >{{
                            item.km_message == 10000
                              ? "恭喜您通过领域测试，请等待平台与您联系签约"
                              : item.km_message == 10001
                              ? "很遗憾，您本次领域测试未通过，我们期待您下次的佳绩！"
                              : item.km_message == 10100
                              ? "恭喜您，您已获得参加领域测试的资格，可以去参加领域测试了"
                              : item.km_message == 10101
                              ? "经人工审核，您未获得领域测试资格。查看失败原因请前往“成为译员”页面，点击下方“查看申请结果”进行查看。"
                              : item.km_message == 20000
                              ? "项目对接人向您指派了一条任务，请及时处理。"
                              : item.km_message == 20401
                              ? "项目对接人关闭了任务，如有问题请于项目对接人联系。"
                              : item.km_message == 20210
                              ? "项目对接人已完成任务准备，请您开始任务。"
                              : item.km_message == 20500
                              ? "项目对接人暂停了任务，如有问题请与项目对接人联系。"
                              : item.km_message == 20501
                              ? "项目对接人已对任务进行变更，请在与项目对接人充分沟通的基础上考虑是否接受变更。"
                              : item.km_message == 20503
                              ? "项目对接人已解除了任务暂停，请按要求继续任务。"
                              : item.km_message == 20305
                              ? "项目对接人发起了返稿修改，请您根据项目对接人要求对任务结果进行调整。"
                              : item.km_message == 20306
                              ? "项目对接人发起了售后工单，请您积极配合修改，以免对您的平台信誉产生影响。"
                              : item.km_message == 20400
                              ? "项目对接人取消了任务，如有问题请于项目对接人联系。"
                              : ""
                          }}</span
                        >
                      </el-tooltip>
                    </p>
                    <p
                      class="t3"
                      :style="item.km_reading ? 'color:#8D92A3' : ''"
                      v-if="item.openTask"
                    >
                      #{{ item.openTask.ot_kfid }}
                      <span style="float: right">{{
                        tool.formatDate(item.km_date_time, "s")
                      }}</span>
                    </p>
                  </li>
                </ul>
                <p v-if="loading" style="margin-top: 10px" class="loading">
                  <span></span>
                </p>
              </el-tab-pane>
              <el-tab-pane label="系统消息" name="b" :disabled="tabFlag">
                <ul
                  style="overflow-y: auto; width: 377px"
                  v-infinite-scroll="load2"
                  :infinite-scroll-disabled="isInfiniteScrollDisabled2"
                >
                  <li
                    class="message"
                    v-for="(item, index) in tableData2"
                    :key="index"
                    @click="toDetail(item.km_message)"
                  >
                    <a :href="item.km_url" target="_blank"
                      ><p
                        class="t1"
                        v-if="item.openTask"
                        :style="item.km_reading ? 'color:#8D92A3' : ''"
                      >
                        {{ item.openTask.ot_name }}
                      </p>
                      <p class="t2" style="margin-bottom: 0; font-size: 14px">
                        <el-tooltip
                          class="item"
                          effect="light"
                          :content="
                            item.km_message == 10000
                              ? '恭喜您通过领域测试，请等待平台与您联系签约'
                              : item.km_message == 10001
                              ? '很遗憾，您本次领域测试未通过，我们期待您下次的佳绩！'
                              : item.km_message == 10100
                              ? '恭喜您，您已获得参加领域测试的资格，可以去参加领域测试了'
                              : item.km_message == 10101
                              ? '经人工审核，您未获得领域测试资格。查看失败原因请前往“成为译员”页面，点击下方“查看申请结果”进行查看。'
                              : ''
                          "
                          placement="bottom"
                        >
                          <span style="display: inline-block">{{
                            item.km_message == 10000
                              ? "恭喜您通过领域测试，请等待平台与您联系签约"
                              : item.km_message == 10001
                              ? "很遗憾，您本次领域测试未通过，我们期待您下次的佳绩！"
                              : item.km_message == 10100
                              ? "恭喜您，您已获得参加领域测试的资格，可以去参加领域测试了"
                              : item.km_message == 10101
                              ? "经人工审核，您未获得领域测试资格。查看失败原因请前往“成为译员”页面，点击下方“查看申请结果”进行查看。"
                              : ""
                          }}</span>
                        </el-tooltip>
                        <span>{{
                          tool.formatDate(item.km_date_time, "s")
                        }}</span>
                      </p>
                      <p class="t3" v-if="item.openTask">
                        #{{ item.openTask.ot_kfid }}
                      </p></a
                    >
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
            <div style="margin-top: 10px; text-align: right">
              <i
                @click="toList()"
                class="el-icon-time"
                style="font-size: 16px; margin-right: 20px; cursor: pointer"
              >
                全部消息</i
              >
              <!-- <i
                class="el-icon-setting"
                style="font-size: 24px; cursor: pointer"
              ></i> -->
            </div>
          </div>
          <el-badge
            :value="num"
            class="item"
            :max="99"
            slot="reference"
            :hidden="num == 0 ? true : false"
          >
            <i class="el-icon-bell"></i>
            <!-- @click="startList()" -->
          </el-badge>
        </el-popover>
        <el-button v-if="!userId" class="reglogin" @click="tologini()"
          >注册/登录</el-button
        >
        <div class="realuser" v-else>
          <span style="vertical-align: middle">
            {{ nickName }}
            <i class="el-icon-caret-bottom icon_style"></i>
          </span>
          <el-avatar
            :size="40"
            :src="phourl"
            style="vertical-align: middle"
          ></el-avatar>
          <ul class="userDownMenu">
            <li @click="tomyTask">工作台</li>
            <li @click="toPersonal">个人中心</li>
            <li @click="toHelp">帮助中心</li>
            <!-- <li @click="toResume">译员认证</li> -->
            <!-- <li @click="toShouru">我的收入</li> -->
            <!-- <li @click="toAccount">账户安全</li> -->
            <!-- <li @click="toTeamOpen">我的团队</li> -->
            <li class="splitLine"></li>
            <li @click="overmove">退出登录</li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Public, Adm } from "@/conf/api";
import tool from "@/tool/tool";
// import SockJS from "sockjs-client";
// import Stomp from "stompjs";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      navActI: null, // nav tab 头部样式
      userId: null, //判断是否登录
      phourl: null,
      nickName: "" || "--",
      // submenuShow: false,
      // ismessage_box: false, //消息提醒
      // hulue: false, //忽略
      // zuixin: [],
      // websocket: '',
      // hongdian: 0,
      // kong: true,
      stompClient: "",
      timer: "",
      activeName: "a",
      lockReconnect: false, //是否真正建立连接
      timeout: 10000, //秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      pages1: 1,
      pages2: 1,
      tableData1: [],
      tableData2: [],
      total1: 1,
      total2: 1,
      tool: tool,
      state: 20000, //消息状态存储
      loading: false,
      isInfiniteScrollDisabled1: false,
      isInfiniteScrollDisabled2: false,
      num: "", //未读消息数量
      token: null,
      tabFlag: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route(to, from) {
      // if (this.$router.history.current.name == "taskOrder") {
      //   this.$router.go(0);
      // }
      this.navActive();
      this.getUserInfo();
      this.token = this.$cookie.get("token");
    },
    token() {
      this.connectWS();
      this.getCount();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.navActive();
    this.getUserInfo();
    this.token = this.$cookie.get("token");
    if (this.$cookie.get("token")) {
      this.connectWS();
      this.getCount();
    }
  },
  //方法集合
  methods: {
    startList() {
      this.tableData1 = [];
      this.pages1 = 1;
      this.activeName = "a";
      let params = {
        sort: 20000, //系统10000 任务20000 全部 0
        page: 1,
        sum: 5,
      };
      this.$axios
        .get(API_1 + Adm.getMessageList, {
          params: params,
        })
        .then((res) => {
          if (res.data.status) {
            this.tableData1 = this.tableData1.concat(res.data.data.list);
            this.total1 = res.data.data.pages;
            this.pages1 += 1;
            this.getCount();
          } else {
            let msg = eval("'" + res.data.message + "'");
            this.$message({
              message: decodeURIComponent(msg),
              type: "error",
            });
          }
        })
        .catch((res) => {});
    },
    toDetail(code) {
      if (code == 10100 || code == 10101) {
        this.$router.push({
          path: "/authenticationState",
        });
      } else if (code == 10000 || code == 10001) {
        this.$router.push({
          path: "/domainList",
        });
      }
    },
    toHelp() {
      this.$router.push({
        path: "/registerAndLogin",
      });
    },
    load1() {
      //滑到底部时进行加载
      setTimeout(() => {
        if (this.pages1 >= this.total1) {
          this.isInfiniteScrollDisabled1 = true;
        } else {
          this.getMsgList1();
        }
      }, 100);
    },
    load2() {
      //滑到底部时进行加载
      if (this.pages2 >= this.total2) {
        this.isInfiniteScrollDisabled2 = true;
      } else {
        this.getMsgList2();
      }
    },
    getCount() {
      this.$axios
        .get(API_1 + Adm.getMessageCount)
        .then((res) => {
          if (res.data.status) {
            this.num = res.data.data.task;
          } else {
            let msg = eval("'" + res.data.message + "'");
            this.$message({
              message: decodeURIComponent(msg),
              type: "error",
            });
          }
        })
        .catch((res) => {});
    },
    getRead(id, tid, code) {
      let params = this.$qs.stringify({
        km_id: id,
      });
      this.$axios
        .put(API_1 + Adm.getMessageList, params)
        .then((res) => {
          let status = res.data.status;
          if (status) {
            if (code == 20306) {
              this.$router.push({
                path: "/myTask",
                query: {
                  state: "task",
                },
              });
            } else {
              let nu = this.$route.query.nu;
              //同一个页面跳 刷新一下 不同的跳转
              if (nu == tid) {
                location.reload();
              } else {
                this.$router.push({
                  path: "/taskOrder",
                  query: {
                    nu: tid,
                  },
                });
              }
            }
          } else {
            let msg = eval("'" + res.data.message + "'");
            this.$message({
              message: decodeURIComponent(msg),
              type: "error",
            });
          }
        })
        .catch((res) => {
          if (res.response.status == 401) {
            this.$router.push("/");
          }
        });
    },
    getMsgList1() {
      this.tabFlag = true;
      let params = {
        sort: 20000, //系统10000 任务20000 全部 0
        page: this.pages1,
        sum: 5,
      };
      this.$axios
        .get(API_1 + Adm.getMessageList, {
          params: params,
        })
        .then((res) => {
          this.tabFlag = false;
          if (res.data.status) {
            this.tableData1 = this.tableData1.concat(res.data.data.list);
            this.total1 = res.data.data.pages;
            this.pages1 += 1;
            this.getCount();
          } else {
            let msg = eval("'" + res.data.message + "'");
            this.$message({
              message: decodeURIComponent(msg),
              type: "error",
            });
          }
        })
        .catch((res) => {
          this.tabFlag = false;
        });
    },
    getMsgList2() {
      this.tabFlag = true;
      let params = {
        sort: 10000, //系统10000 任务20000 全部 0
        page: this.pages2,
        sum: 7,
      };
      this.$axios
        .get(API_1 + Adm.getMessageList, {
          params: params,
        })
        .then((res) => {
          this.tabFlag = false;
          if (res.data.status) {
            this.tableData2 = this.tableData2.concat(res.data.data.list);
            this.total2 = res.data.data.pages;
            this.pages2 += 1;
          } else {
            let msg = eval("'" + res.data.message + "'");
            this.$message({
              message: decodeURIComponent(msg),
              type: "error",
            });
          }
        })
        .catch((res) => {
          this.tabFlag = false;
        });
    },
    guanbi() {
      this.ws.onclose();
    },
    clickME() {
      this.ws.send("我是文本");
    },
    connectWS() {
      //ws://192.168.2.198:7100/ ws://192.168.3.136:7100/
      console.log("开始连接");
      //
      let wsuri =
        "ws://180.76.151.47:7100/ws?Authorization:" + this.$cookie.get("token");
      //192.168.0.196:8080
      this.ws = new WebSocket(wsuri);
      this.ws.onopen = this.onopen;
      this.ws.onmessage = this.onmessage;
      this.ws.onclose = this.onclose;
      this.ws.onerror = this.onerror;
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.connectWS();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      //that.start();
    },
    start() {
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        self.ws.send("我是心跳");
        // if (self.ws.readyState == 1) {
        //   //如果连接正常
        //   self.ws.send("我是心跳");
        // } else {
        //   //否则重连
        //   self.reconnect();
        // }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.ws.close();
        }, self.timeout);
      }, self.timeout);
    },
    onopen() {
      //开启心跳
      //this.start();
    },
    onmessage(e) {
      //获取websocket推送的数据
      let data = JSON.parse(e.data);
      let info = data.openTask;
      if (data.km_message == 10000) {
        this.$notify.success({
          title: "领域测试通过",
          content: " 恭喜您通过领域测试，请等待平台与您联系签约",
          duration: 10000,
        });
      } else if (data.km_message == 10001) {
        this.$notify.warning({
          title: "领域测试未通过",
          content: "很遗憾，您本次领域测试未通过，我们期待您下次的佳绩！",
          duration: 10000,
        });
      } else if (data.km_message == 10100) {
        this.$notify.success({
          title: "申请领域测试通过",
          content: " 恭喜您，您已获得参加领域测试的资格，可以去参加领域测试了",
          duration: 10000,
        });
      } else if (data.km_message == 10101) {
        this.$notify.success({
          title: "申请领域测试未通过",
          content:
            "经人工审核，您未获得领域测试资格。查看失败原因请前往“成为译员”页面，点击下方“查看申请结果”进行查看。",
          duration: 10000,
        });
      } else if (data.km_message == 20000) {
        this.$notify.success({
          title: "收到新的指派任务",
          content: "项目对接人向您指派了一条任务，请及时处理。",
          duration: 10000,
        });
      } else if (data.km_message == 20401) {
        this.$notify.error({
          title: "任务关闭",
          content: "项目对接人关闭了任务，如有问题请于项目对接人联系。",
          duration: 10000,
        });
      } else if (data.km_message == 20210) {
        this.$notify.warning({
          title: "等待开始任务",
          content: "项目对接人已完成任务准备，请您开始任务。",
          duration: 10000,
        });
      } else if (data.km_message == 20500) {
        this.$notify.warning({
          title: "任务暂停",
          content: "项目对接人暂停了任务，如有问题请与项目对接人联系。",
          duration: 0,
        });
      } else if (data.km_message == 20501) {
        this.$notify.warning({
          title: "任务请求变更",
          content:
            "项目对接人已对任务进行变更，请在与项目对接人充分沟通的基础上考虑是否接受变更。",
          duration: 0,
        });
      } else if (data.km_message == 20503) {
        this.$notify.success({
          title: "任务暂停解除",
          content: "项目对接人已解除了任务暂停，请按要求继续任务。",
          duration: 10000,
        });
      } else if (data.km_message == 20305) {
        this.$notify.warning({
          title: "返稿修改",
          content:
            "项目对接人发起了返稿修改，请您根据项目对接人要求对任务结果进行调整。",
          duration: 10000,
        });
      } else if (data.km_message == 20306) {
        this.$notify.warning({
          title: "售后工单",
          content:
            "项目对接人发起了售后工单，请您积极配合修改，以免对您的平台信誉产生影响。",
          duration: 10000,
        });
      } else if (data.km_message == 20400) {
        this.$notify.error({
          title: "任务取消",
          content: "项目对接人取消了任务，如有问题请于项目对接人联系。",
          duration: 10000,
        });
      }
      // this.$notify({
      //   title: "成功",
      //   message: "这是一条成功的提示消息",
      //   type: "success",
      // });

      //console.log(e, "我是收到的");
      // this.start();
      // if (obj.status == 5) {
      //   //心跳超时
      //   this.ws.close();
      // } else {
      //   //收到服务器信息，心跳重置
      //   this.reset();
      // }
    },
    onclose(e) {
      console.log(e);
      console.log("连接关闭");
      clearTimeout(this.timeoutObj);
      clearTimeout(this.serverTimeoutObj);
      if (this.$cookie.get("token")) {
        //重连
        this.reconnect();
      }
    },
    onerror(e) {
      console.log("出现错误");
      //重连
      this.reconnect();
    },
    toList() {
      this.$router.push({
        path: "/messageCenter",
      });
    },
    handleClick(tab) {
      this.tableData1 = [];
      this.pages1 = 1;
      this.pages2 = 1;
      this.total1 = 1;
      this.total2 = 1;
      this.tableData2 = [];
      this.isInfiniteScrollDisabled1 = false;
      this.isInfiniteScrollDisabled2 = false;
      if (tab.name == "a") {
        this.load1();
        this.getMsgList1();
      } else if (tab.name == "b") {
        this.load2();
        this.getMsgList2();
      }
    },

    // 获取用户数据
    getUserInfo() {
      if (this.$cookie.get("uid")) {
        this.userId = true;
        this.$axios
          .get(API_1 + Adm.getUserInfo)
          .then((res) => {
            if (res.data.status) {
              this.phourl =
                res.data.data.us_portrait ||
                require("@/assets/bio/touxiang.png");
              this.nickName = res.data.data.us_nickname;
            } else {
            }
            this.$cookie.set("photUrl", this.phourl, "90d");
            this.$cookie.set("nickName", this.nickName, "90d");
          })
          .catch((err) => {});
      } else {
        this.userId = false;
      }
    },

    // 判断选择的那个tab
    navActive() {
      let _path = this.$route.path;
      if (_path.indexOf("/index") > -1) {
        this.navActI = 1;
      } else if (_path.indexOf("/taskHall") > -1) {
        this.navActI = 2;
      } else if (_path.indexOf("/category") > -1) {
        this.navActI = 3;
      } else if (_path.indexOf("/catIntro") > -1) {
        this.navActI = 4;
      } else if (_path.indexOf("/about") > -1) {
        this.navActI = 5;
      } else if (_path.indexOf("/contactUs") > -1) {
        this.navActI = 6;
      } else {
        this.navActI = 1;
      }
    },
    toIndex() {
      if (this.$route.path == "/") {
        window.scrollTo(0, 0);
      } else {
        this.$router.push("/");
      }
    },
    // 去首页
    toIndex() {
      this.$router.push("/");
    },
    toZMList() {
      this.$router.push("/recruitList");
    },
    toRecruit() {
      this.$router.push("/taskHall");
    },
    toCategory() {
      this.$router.push("/category");
    },
    toCAT() {
      // this.$router.push('/catIntro')
    },
    toAbout() {
      this.$router.push("/about");
    },
    tologini() {
      this.$router.push("/login");
    },
    toPersonal() {
      this.$router.push("/personalCenter");
    },
    tomyTask() {
      this.$router.push("/myTask");
    },
    // 退出登录
    overmove() {
      sessionStorage.clear();
      localStorage.clear();
      this.$cookie.remove("uid");
      this.$cookie.remove("token");
      this.$router.push("/");
      this.getUserInfo();
      this.$message.warning("请登录后查看更多信息！");
      this.ws.onclose();
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.el-notification {
  border-radius: 4px !important;
  border-left: 4px solid #3e78ff !important;
}
.el-icon-bell {
  cursor: pointer;
  color: #fff;
}
.messagePop {
  padding: 0 !important;
  width: auto !important;
  .messageBox {
    width: 366px;
    min-height: 516px;
    background: #ffffff;
    box-shadow: 2px 2px 18px 0px rgba(45, 62, 122, 0.24);
    border-radius: 6px;
    padding: 10px;
    ul {
      height: 470px;
    }
    .message {
      padding: 10px;
      border-bottom: 1px solid #e4e7ed;
      cursor: pointer;
      &:hover {
        background: #f9fafc;
      }
      .t1 {
        font-weight: bold;
        font-size: 16px;
        color: #303133;
        overflow: hidden; /*内容超出后隐藏*/
        text-overflow: ellipsis; /*超出内容显示为省略号*/
        white-space: nowrap; /*文本不进行换行*/
        width: 350px;
        margin-bottom: 10px;
      }
      .t2 {
        font-weight: 400;
        font-size: 12px;
        color: #606266;
        margin-bottom: 10px;
        // display: flex;
        // justify-content: space-between;
        span {
          overflow: hidden; /*内容超出后隐藏*/
          text-overflow: ellipsis; /*超出内容显示为省略号*/
          white-space: nowrap; /*文本不进行换行*/
          width: 325px;
          display: inline-block;
        }
      }
      .t3 {
        font-weight: 400;
        font-size: 12px;
        color: #8d92a3;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
//@import url(); 引入公共css类
header {
  font-family: PingFang SC, PingFang SC;
  height: 60px;
  width: 100%;
  background: #212328;
  min-width: 1200px;
  box-shadow: 2px -2px 15px 0px rgba(98, 100, 105, 0.08);
  position: sticky;
  top: 0;
  z-index: 999;
  ::v-deep .el-badge__content.is-fixed {
    top: 15px;
  }
  .item {
    margin-right: 30px;
  }
}

.main {
  height: 60px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1920px;
  padding: 0 24px;

  .logo {
    width: 190px;
    height: 39px;
    cursor: pointer;
  }

  .head_nav {
    // float: left;
    margin-left: 20px;
    width: 696px;

    .displayFlex {
      display: flex;

      li {
        margin: 0 30px;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        font-weight: 400;
        color: #cacaca;
        // opacity: 0.8;
        cursor: pointer;
        position: relative;
      }

      li:hover,
      li.active {
        // opacity: 1;
        color: #fff;
      }

      // .active::after {
      //   position: absolute;
      //   display: block;
      //   content: "";
      //   width: 100%;
      //   height: 4px;
      //   background: #4385ff;
      //   border-radius: 2px;
      //   left: 0;
      //   bottom: 0px;
      // }
      .special {
        background: url(../assets/headers/topicon.png) no-repeat center center;
        background-size: 106px 32px;
        width: 106px;
        height: 60px;
        line-height: 60px;
      }
    }
  }

  .realuserBox {
    position: relative;
    float: right;
    text-align: right;
    width: 350px;
    line-height: 60px;
    .reglogin {
      width: 111px;
      height: 40px;
      background: #675dfb;
      border-radius: 3px 3px 3px 3px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: 0;
      &:hover {
        background: #5d77fb;
      }
    }
    .realuser {
      display: inline-block;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
      position: relative;
      color: #fff;

      span {
        margin: 0 4px;
      }

      img {
        width: 42px;
        height: 42px;
        border-radius: 50%;
      }

      .userDownMenu {
        position: absolute;
        display: none;
        width: 138px;
        top: 60px;
        z-index: 100;
        border-radius: 4px;
        overflow: hidden;
        right: 0;
        background-color: #fff;
        box-shadow: 0 0 6px 0 rgb(0 0 0 / 40%);
        z-index: 99999;

        li {
          height: 40px;
          text-align: center;
          color: #666;
          line-height: 40px;
          cursor: pointer;
          font-size: 14px;
          font-family: Microsoft YaHei;
          padding: 0 20px;
        }

        li:hover {
          background: rgba(89, 125, 252, 0.04);
          color: #457afa;
        }

        li:last-of-type:hover {
          color: #f66665;
          background: #fff;
        }

        .splitLine {
          width: 98px;
          height: 0;
          margin: 10px 20px;
          border-bottom: 1px solid #eee;
        }
      }
    }

    .realuser:hover .userDownMenu {
      display: block;
    }
  }
}
</style>
